import * as React from 'react';

const Duplicate24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M2.99953 4.25C3.41365 4.25 3.74938 4.58591 3.74953 5V19.7695C3.74961 19.8968 3.80029 20.0193 3.89015 20.1094C3.98013 20.1994 4.10277 20.2498 4.23 20.25H18.9995C19.4137 20.25 19.7494 20.5859 19.7495 21C19.7495 21.4142 19.4137 21.75 18.9995 21.75H4.23C3.70494 21.7498 3.20089 21.5412 2.82961 21.1699C2.45844 20.7986 2.24961 20.2946 2.24953 19.7695V5C2.24967 4.58607 2.58562 4.25025 2.99953 4.25ZM19.8452 2.25C20.8966 2.25 21.7494 3.10295 21.7495 4.1543V16.8457C21.7495 17.8972 20.8967 18.75 19.8452 18.75H7.15382C6.10258 18.7497 5.24953 17.897 5.24953 16.8457V4.1543C5.24967 3.10311 6.10266 2.25025 7.15382 2.25H19.8452ZM7.15382 3.75C6.93109 3.75025 6.74967 3.93154 6.74953 4.1543V16.8457C6.74953 17.0686 6.931 17.2497 7.15382 17.25H19.8452C20.0683 17.25 20.2495 17.0687 20.2495 16.8457V4.1543C20.2494 3.93138 20.0682 3.75 19.8452 3.75H7.15382ZM13.4995 6.75C13.9137 6.75 14.2494 7.08591 14.2495 7.5V9.75H16.4995C16.9137 9.75 17.2494 10.0859 17.2495 10.5C17.2495 10.9142 16.9137 11.25 16.4995 11.25H14.2495V13.5C14.2495 13.9142 13.9137 14.25 13.4995 14.25C13.0855 14.2497 12.7495 13.9141 12.7495 13.5V11.25H10.4995C10.0855 11.2497 9.74953 10.9141 9.74953 10.5C9.74967 10.0861 10.0856 9.75025 10.4995 9.75H12.7495V7.5C12.7497 7.08607 13.0856 6.75025 13.4995 6.75Z'
				fill='black'
			/>
		</svg>
	);
};

export default Duplicate24;

